import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import HourEditor from '@/routes/hours/HourEditor'
import { hourEditorRouteAction, hourEditorRouteLoader } from '@/routes/hours/HourEditor.route'
import { RoleRouteObject } from '@/types'

const HourCreatorRoute = {
  path: 'new',
  element: <HourEditor creating={true} />,
  loader: hourEditorRouteLoader,
  action: hourEditorRouteAction,
  allowedRoles: [
    Roles.GlobalAdministrator,
    Roles.Administrator,
    Roles.Marketing,
    Roles.TechDeveloper,
    Roles.Sales,
    Roles.Supervisor,
  ],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default HourCreatorRoute
